import {
  CalendarDays,
  Clock,
  Info,
  type LucideIcon,
  Megaphone,
  PartyPopper,
  TriangleAlert,
} from "lucide-react";
import type { AnnouncementIcon } from "@/schemas/announcements";

/** The built-in announcement icons an admin can pick from. */
export const ANNOUNCEMENT_ICONS: Record<AnnouncementIcon, LucideIcon> = {
  megaphone: Megaphone,
  calendar: CalendarDays,
  clock: Clock,
  celebration: PartyPopper,
  alert: TriangleAlert,
  info: Info,
};
